import BudgetsPage from '@/views/budgets-page'
import BudgetsTransfer from '@/views/budget-transfer'
import CardTopup from '@/views/card-topup'
import CardTransfer from '@/views/card-transfer'
import CategoriesPage from '@/views/categories-page'
import CompanyPage from '@/views/company-page'
import helpers from '@/utils/helpers'
import HelpPage from '@/views/help-page'
import LoginScreen from '@/views/login-screen'
import MakeRequest from '@/views/make-request'
import ManageBudget from '@/views/manage-budget'
import ManageRequests from '@/views/manage-requests'
import MyCard from '@/views/my-card'
import MyRequests from '@/views/my-requests'
import MySpend from '@/views/my-spend'
import PageNotFound from '@/views/page-not-found'
import SettingsPage from '@/views/settings-page'
import ReportPage from '@/views/report-page'
import RequestPage from '@/views/request-page'
import TransactionPage from '@/views/transaction-page'
import UsersList from '@/views/users-list'
import UserPage from '@/views/user-page'
import ManageTags from "@/views/ManageTags";

export default {
  computed: {
    routes () {
      return [
        // user routes
        {path: this.links.root, redirect: this.redirectHome, options: {animate: false}},
        {path: this.links.login, loginScreen: {component: LoginScreen}},
        {path: this.links.myRequests, async: this.checkAuth(MyRequests), options: {animate: false}},
        {path: this.links.makeRequest, async: this.checkAuth(MakeRequest), options: {animate: false}},
        {path: this.links.myCard, async: this.checkAuth(MyCard), options: {animate: false}},
        {path: this.links.spend, async: this.checkAuth(MySpend), options: {animate: false}},
        {path: `${this.links.transaction}/:id`, async: this.checkAuth(TransactionPage), options: {animate: false}},
        {path: `${this.links.request}/:id`, async: this.checkAuth(RequestPage), options: {animate: false}},
        {path: this.links.profile, async: this.checkAuth(UserPage), options: {animate: false}},
        {path: this.links.cardTransfer, async: this.checkAuth(CardTransfer), options: {animate: false}},
        {path: this.links.help, async: this.checkAuth(HelpPage), options: {animate: false}},
        {path: this.links.settings, async: this.checkAuth(SettingsPage), options: {animate: false}},
        // manager routes
        {path: this.links.budgets, async: this.checkAuth(BudgetsPage, 'manager'), options: {animate: false}},
        {path: `${this.links.budgetTransfer}/:from_budget_id?/:to_budget_id?`, async: this.checkAuth(BudgetsTransfer, 'manager'), options: {animate: false}},
        {path: `${this.links.topUpCard}/:budget_id?/:user_id?`, async: this.checkAuth(CardTopup, 'manager'), options: {animate: false}},
        {path: `${this.links.budget}/:id`, async: this.checkAuth(ManageBudget, 'manager')},
        {path: `${this.links.manageRequests}/:budget_id?`, async: this.checkAuth(ManageRequests, 'manager'), options: {animate: false}},
        {path: `${this.links.request}/:id/:manage`, async: this.checkAuth(RequestPage, 'manager'), options: {animate: false}},
        {path: `${this.links.report}/:budget_id?`, async: this.checkAuth(ReportPage, 'manager')},
        // admin routes
        {path: this.links.users, async: this.checkAuth(UsersList, 'admin')},
        {path: this.links.budget, async: this.checkAuth(ManageBudget, 'admin')},
        {path: this.links.company, async: this.checkAuth(CompanyPage, 'admin'), options: {animate: false}},
        {path: this.links.categories, async: this.checkAuth(CategoriesPage, 'admin')},
        {path: this.links.manageTags, async: this.checkAuth(ManageTags, 'admin')},
        {path: `${this.links.user}/:id`, async: this.checkAuth(UserPage, 'admin')},
        {path: `${this.links.cardTransfer}/:user_id`, async: this.checkAuth(CardTransfer, 'admin'), options: {animate: false}},
        // catch default route
        {path: this.links.logout, async: this.logout},
        {path: '(.*)', component: PageNotFound}
      ]
    }
  },
  methods: {
    checkAuth (component, role) {
      return async (to, from, resolve) => {
        if (this.isLoggedIn()) {
          // Fetch the user object if we don't have it (so we can use it to check auth)
          if (!('email' in this.$store.state.user)) {
            await this.$store.dispatch('fetchUser')
          }
          switch (role) {
            case 'admin':
              this.isAdmin ? resolve({component: component}) : resolve({component: PageNotFound})
              break
            case 'manager':
              this.isManager ? resolve({component: component}) : resolve({component: PageNotFound})
              break
            default:
              resolve({component: component})
          }
        } else resolve({loginScreen: {component: LoginScreen}})
      }
    },
    logout () {
      localStorage.removeItem('levima_api_key')
      localStorage.removeItem('aio_current_user_id')
      this.$store.commit('clear')
      this.$f7router ? this.$f7router.navigate(this.links.root) : this.$f7.views.main.router.navigate(this.links.root)
    },
    redirectHome (route, resolve) {
      if (this.isLoggedIn()) resolve(this.getHome())
      else resolve(this.links.login)
    },
    getHome() {
      return this.isManager ? this.links.budgets : this.links.myCard
    }
  },
  mounted () {
    let currentPopup = null
    this.Dom7('body').on('popup:opened', event => {
      currentPopup = this.$f7.popup.get(event.target)
    })
    this.Dom7('body').on('popup:closed', event => {
      let closedPopup = this.$f7.popup.get(event.target)
      if (closedPopup === currentPopup) {
        currentPopup = null
      }
    })

    document.addEventListener("backbutton", event => {
      // TODO: this doesn't get called in a browser
      if (currentPopup != null) {
        // Close any open popups
        currentPopup.close()
        currentPopup = null
        return
      }

      if (this.$f7.panel.left.opened) {
        // Close the panel if it's open.
        this.$f7.panel.left.close()
        return
      }

      let currentUrl = this.$f7.views.main.router.currentRoute.url
      let router = this.$f7.view.main.router

      let quitLinks = [
        this.links.login,
        this.getHome()
      ]

      let topLevelLinks = [
        this.links.myRequests,
        this.links.manageRequests,
        this.links.company,
        this.links.myCard,
        this.links.budgets
      ]

      if (quitLinks.some(url => url === currentUrl)) {
        // If we're on one of the root pages, quit the app
        navigator.app.exitApp()
      } else if (topLevelLinks.some(url => url === currentUrl)) {
        // If we're on any of the non-root top-level pages, go back to root and clear history.
        router.navigate(this.links.root, { clearPreviousHistory: true })
      } else {
        // Otherwise use the router back.
        router.back()
      }
    })
  },
  async beforeCreate () {
    await this.$store.dispatch('fetchTeam')
    await this.$store.dispatch('fetchExpenses')
    await this.$store.dispatch('budgets/fetch')
  },
  mixins: [helpers]
}
